export default __webpack_public_path__ + "static/media/IMG_1993.f50256ec.JPG";